import { render, staticRenderFns } from "./AppCrossIcon.vue?vue&type=template&id=117ef3b4&scoped=true&"
import script from "./AppCrossIcon.vue?vue&type=script&lang=js&"
export * from "./AppCrossIcon.vue?vue&type=script&lang=js&"
import style0 from "./AppCrossIcon.vue?vue&type=style&index=0&id=117ef3b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117ef3b4",
  null
  
)

export default component.exports